<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M13.2079 3.87567C13.0645 3.83822 12.9337 3.76319 12.829 3.65834L11.4265 2.25584C11.2397 2.06902 10.2499 1.09973 10.0059 0.998627C9.76179 1.09973 8.76826 2.06902 8.58146 2.25584L7.17896 3.6575C7.0741 3.76225 6.99907 3.89308 6.96162 4.03648C6.92417 4.17989 6.92564 4.33069 6.96589 4.47334C7.00614 4.61599 7.0837 4.74532 7.19059 4.848C7.29747 4.95069 7.42981 5.023 7.57396 5.0575C7.93407 5.14389 8.26465 5.3247 8.53165 5.58132C8.79865 5.83795 8.99242 6.1611 9.093 6.51751C9.19359 6.87392 9.19735 7.2507 9.10391 7.60904C9.01047 7.96739 8.82319 8.29435 8.56137 8.55626C8.29955 8.81816 7.97265 9.00555 7.61434 9.09911C7.25602 9.19267 6.87924 9.18903 6.5228 9.08857C6.16636 8.9881 5.84314 8.79444 5.58643 8.52752C5.32972 8.26061 5.14879 7.93009 5.06229 7.57C5.02779 7.42586 4.95547 7.29352 4.85279 7.18663C4.75011 7.07975 4.62077 7.00219 4.47813 6.96194C4.33548 6.92169 4.18468 6.92022 4.04127 6.95767C3.89786 6.99512 3.76704 7.07014 3.66229 7.175L2.25979 8.5775C2.07298 8.7643 1.10696 9.75455 1.00586 9.99863C1.10696 10.2427 2.07298 11.2357 2.25979 11.4225L3.66229 12.8242C3.76715 12.9289 3.84217 13.0597 3.87962 13.2032C3.91707 13.3466 3.9156 13.4974 3.87535 13.64C3.83511 13.7827 3.75754 13.912 3.65066 14.0147C3.54377 14.1174 3.41144 14.1897 3.26729 14.2242C2.90718 14.3106 2.5766 14.4914 2.3096 14.748C2.0426 15.0046 1.84883 15.3278 1.74824 15.6842C1.64765 16.0406 1.64389 16.4174 1.73733 16.7757C1.83078 17.1341 2.01805 17.461 2.27987 17.7229C2.54169 17.9848 2.86859 18.1722 3.22691 18.2658C3.58522 18.3593 3.962 18.3557 4.31844 18.2552C4.67489 18.1548 4.99811 17.9611 5.25482 17.6942C5.51153 17.4273 5.69245 17.0968 5.77895 16.7367C5.81345 16.5925 5.88577 16.4602 5.98845 16.3533C6.09114 16.2464 6.22047 16.1688 6.36312 16.1286C6.50577 16.0884 6.65657 16.0869 6.79997 16.1243C6.94338 16.1618 7.0742 16.2368 7.17896 16.3417L8.58146 17.7442C8.76826 17.931 9.76179 18.8975 10.0059 18.9986C10.2499 18.8975 11.2397 17.931 11.4265 17.7442L12.829 16.3425C12.9338 16.2377 13.0088 16.1069 13.0463 15.9635C13.0837 15.8201 13.0823 15.6693 13.042 15.5267C13.0018 15.384 12.9242 15.2547 12.8173 15.152C12.7104 15.0493 12.5781 14.977 12.434 14.9425C12.0738 14.8561 11.7433 14.6753 11.4763 14.4187C11.2093 14.1621 11.0155 13.8389 10.9149 13.4825C10.8143 13.1261 10.8106 12.7493 10.904 12.391C10.9974 12.0326 11.1847 11.7057 11.4465 11.4437C11.7084 11.1818 12.0353 10.9945 12.3936 10.9009C12.7519 10.8073 13.1287 10.811 13.4851 10.9114C13.8416 11.0119 14.1648 11.2056 14.4215 11.4725C14.6782 11.7394 14.8591 12.0699 14.9456 12.43C14.9801 12.5741 15.0524 12.7065 15.1551 12.8134C15.2578 12.9203 15.3871 12.9978 15.5298 13.0381C15.6724 13.0783 15.8232 13.0798 15.9666 13.0423C16.11 13.0049 16.2409 12.9299 16.3456 12.825L17.7481 11.4225C17.9349 11.2357 18.9048 10.2427 19.0059 9.99863C18.9048 9.75455 17.9349 8.7643 17.7481 8.5775L16.3456 7.17584C16.2408 7.07108 16.1657 6.94026 16.1283 6.79685C16.0908 6.65345 16.0923 6.50265 16.1326 6.36C16.1728 6.21735 16.2504 6.08802 16.3573 5.98533C16.4641 5.88265 16.5965 5.81033 16.7406 5.77584C17.1007 5.68945 17.4313 5.50864 17.6983 5.25201C17.9653 4.99539 18.1591 4.67224 18.2597 4.31583C18.3603 3.95942 18.364 3.58264 18.2706 3.22429C18.1771 2.86595 17.9899 2.53899 17.728 2.27708C17.4662 2.01517 17.1393 1.82779 16.781 1.73423C16.4227 1.64066 16.0459 1.6443 15.6895 1.74477C15.333 1.84524 15.0098 2.0389 14.7531 2.30582C14.4964 2.57273 14.3155 2.90325 14.229 3.26334C14.1945 3.40748 14.1221 3.53982 14.0195 3.6467C13.9168 3.75359 13.7874 3.83115 13.6448 3.8714C13.5021 3.91165 13.3513 3.91312 13.2079 3.87567Z"
			:fill="computedFill"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconImplementor',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: '#838091'
		},
		filled: {
			type: Boolean,
			default: false
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.3
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
